import { Action, ActionReducer, combineReducers } from '@ngrx/store';
import { SitesView } from '../../../_generated';
import { RequestStatus } from '../../actionstypes/request-status/request-status.actiontype';
import { SitesRequestStatusAction } from '../../actionstypes/sites/sites-request-status.actiontype';
import requestStatusReducer from '../request-status/request-status.reducer';
import sitesReducer from './sites.reducer';

export interface RootSites {
  requestStatus: RequestStatus;
  data: SitesView[];
}

export const sitesRootReducer = combineReducers({
  requestStatus: requestStatusReducer(SitesRequestStatusAction.Load, SitesRequestStatusAction.Success, SitesRequestStatusAction.Error),
  data: sitesReducer as ActionReducer<SitesView[], Action<string>>,
});
